export default __webpack_public_path__ + "static/howitworks4-2f09f61c13e47dd4a6e4554a2cc5c205.svg";